// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__X+Y0l","disabled":"radio_disabled__66UUM"};